const section = "_7cs1gatp39";

export { section };
import "./comp.section.style.linaria.module.css";
//# sourceMappingURL=comp.section.style.js.map
